export const RESET_USER_RECOVERED_PASSWORD = '@user/ResetUserRecoveredPassword'
export const RECOVER_USER_PASSWORD_REQUEST = '@user/RecoverUserPasswordRequest'
export const RECOVER_USER_PASSWORD_FAILURE = '@user/RecoverUserPasswordFailure'
export const RECOVER_USER_PASSWORD_SUCCESS = '@user/RecoverUserPasswordSuccess'
